<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2024-01-02 14:33:11
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-01 11:23:27
 * @Description: 
        这是游戏下方大表格被点击之后弹出的窗口，显示游戏历史开局结果 
        接收 historyDetail 入参触发弹出窗口
        也监听 route 变化弹出窗口 
        当前组件引用名： <CasinoHistoryModalGameDetali
-->

<template>
    <ClientOnly>
        <CasinoHistoryModalWavesDetail
            v-if="isFuturesGame && history?.['_id']"
            v-model="showModal" 
            @hideModel="emit('hideModel')"
            @update:model-value="onUpdateModelValue"
            :history="history as any" 
            :fnCashOut="wavesFnCashOut"
        />
        <!--
            ↑ 期货合约详情专用
            ↓ 其它各个游戏通用历史窗口
        --> 
        <ModalMobile
            v-else-if="!isFuturesGame && history"
            v-model="showModal"
            @hideModel="emit('hideModel')"
            @update:model-value="onUpdateModelValue"
            :containerClass="'max-w-[96vw]'"
        >
            <template v-slot:header>
                <div class="flex text-white flex-col gap-2 justify-center">
                    <span>
                        {{ t.GameDetails.BetDetails }}
                    </span>
                </div>
            </template>
            <!-- ↑ 顶部 header -->
            <!-- ↓ 这是弹出窗 口的核心内容 -->
            <div 
                class="max-h-[75vh] overflow-auto !overflow-x-hidden text-white mx-[-24px] px-[24px]"
                :ref="el => el && (contentRef = el)"
            >
                <CasinoHistoryModalGameDetaliInfo
                    class="w-full mb-2"
                    :history="history"
                />
                <!-- ↑ 通用游戏信息：游戏名，用户名，时间，单号 -->
                <!-- ↓ 下注金额，倍数，提现金额；这里的 v-show 是后加的，防止显示出上一局的金额信息 -->
                <CasinoHistoryModalGameDetaliDetail
                    :history="history"
                    v-show="history._id && showCommonAmountFinfo"
                />
                <!-- ↓ 重要部分，呈现游戏结果 -->
                <CasinoHistoryGameContent
                    class="mt-2"
                    :history="history"
                    :fnScrollMove="fnScrollMove"
                    :gameDropValue="gameDropValue"
                    @handleSelectItem="handleSelectItem"
                    :currentIndex="currentIndex"
                />
                <!-- ↓ 显示游戏公平性信息 -->
                <CasinoHistoryModalGameDetaliFairness
                    v-if="showHashBar"
                    class="mt-2"
                    :history="history"
                    :fairness="oFairness"
                    :fnScrollMove="fnScrollMove"
                    @handlePrinciple="fnHandlePrinciple"
                    :currentIndex="currentIndex"
                />
            </div>
        </ModalMobile>
    </ClientOnly>
</template>

<script lang="ts">
export default defineComponent({
    name: 'CasinoHistoryModalGameDetali',
});
</script>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import { useGameHistorySocket } from '~/socket/gamehistory';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { getInfo4Rows } from '@/pages/casino/futuresGame/ts/wavesFn'; 
import {useRedPacket} from '@/socket/game/redpacket'; 
import {fnOperateHistoryDetail} from '@/pages/casino/redpacketGame/ts/redPacketCommon'; 
import { useGoldenFlower } from '@/socket/game/goldenFlower';
 
// ↓ 为显示 waves 游戏的内容，补充以 waves 开头的参数
const props = defineProps({
    wavesFnCashOut: {
        type: Function, 
    },
    historyDetail: {
        type: Object,
    },
    gameDropValue: { // 游戏名 
        type: String,
        default: '',
    }
});

const route = useRoute();
const router = useRouter();
const { EMIT_BET_DETAILS } = useGameHistorySocket();
const { EMIT_GET_REDPACKET_DETAIL } = useRedPacket();
const { EMIT_ZHAJINHUA_DETAIL } = useGoldenFlower();
const t = useTranslation();
const emit = defineEmits(['handlePrinciple','hideModel']);
// ↑ 公共内容 
// ↓ 组件内部变量 
const contentRef = ref({}); // 之前默认值为 null，但控制台一直报错 
const history = ref<BetHistoryType>();
const showModal = ref(false);
const isFuturesGame = ref(false); // 历史数据id 包含 `futures:` 得到 true 
const isRedpacketGame = ref(false); // 历史数据id 包含 `redpacket:` 得到 true 
const isGoldenflowerGame = ref(false); // 历史数据id 包含 `goldenFlower:` 得到 true 
const currentIndex = ref(0); // coinflip multiply模式使用
let hasPrincipleShowed = false; // 是否“曾” 打开公平性原理窗口 

// ↓ 显示 hash 栏 
const showHashBar = computed(()=>{
    const aNoHashGames = [
        'redpacket', 
        'goldenFlower',
        'niuniu',
        // 逐个添加...  
    ];
    const noHashGame = aNoHashGames.includes(props.gameDropValue);
    return noHashGame == false;
});

// ↓ 显示金额倍率信息 
const showCommonAmountFinfo = computed(()=>{
    const aGames = [
        'redpacket', 
        'goldenFlower',
        'niuniu', // 牛牛游戏单独处理，不显示通用金额信息
        // 逐个添加...  
    ];
    const noCommonAmount = aGames.includes(props.gameDropValue);
    return noCommonAmount == false;
});

// ↓ 应对当前组件自身的开/关事件  
// ↓ 窗口可见性变化后，新值会传入此方法 
const onUpdateModelValue = (value: boolean) => {
    showModal.value = value;
    if (!showModal.value){
        history.value['_id'] = null; // 关窗口，则清空 ID 
    }
    const preservedQuery: Record<string, any> = {};
    if (route.query.tab) preservedQuery.tab = route.query.tab;
    if (route.query.name) preservedQuery.name = route.query.name;
    if (route.query.src) preservedQuery.src = route.query.src;

    router.push({
        replace: true,
        path: route.path,
        query: Object.keys(preservedQuery).length ? preservedQuery : undefined,
    });
};

// ↓ 有些游戏的 fairness 信息特殊，此变量用于保存特殊值。目前用于 Hilo 
const oFairness = ref(null);
function fnUpdateFairness(oData){
    // console.log("收到了 fairness", deepCopy(oData));
    oFairness.value = deepCopy(oData as any);
}

let taskID = null;
// ↓ 用于将滚动条向下滚动一段距离（交给子组件调用） 
function fnScrollMove(iMovePx){
    clearInterval(taskID);
    // console.log('开始滚动', iMovePx, contentRef.value);
    // ↓ 计划总耗时，频率(帧率) 
    const [iTime2Use, iFrequency] = [600, Math.ceil(1000/30)];
    let iTimesGo = iTime2Use / iFrequency;
    const iOneStepLong = Math.ceil(iMovePx / iTimesGo);
    taskID = setInterval(()=>{
        if (iTimesGo < 0 || !contentRef.value){
            clearInterval(taskID);
        }
        contentRef.value['scrollTop'] += iOneStepLong;
        iTimesGo--;
    }, iFrequency);
}

provide('fnUpdateFairness', fnUpdateFairness);



// ↓ 监听以便适时打开窗口
watch(
    () => route.query,
    getOneFnForHistory('query'),
    { immediate: true, },
);

// ↓ 监听 historyDetail 直接在当前页面打开窗口，不需要跳转打开窗口
watch(
    () => props.historyDetail,
    getOneFnForHistory('historyDetail'),
    { immediate: true, },
)

function getOneFnForHistory(
    type: 'query' | 'historyDetail',
){
    const fnResult = (newVal) => {
        if (import.meta.server || !newVal) return;
        if (1 && import.meta.dev){
            console.log('即将显示历史记录。受命渠道：', type);
        }
        const {
            // ↓ 调用方有义务传递规范的完整的 id 值，以用于查询
            // ↓ 下方参数 id 格式示例 => dice:33449 ◆ 这里分号左侧的游戏名同于地址栏名对应的纯小写 api 值  
            data: id='',
            modal: modalQueryParam,
            playerId, // 红包游戏专属 
            gamePlayId, // 炸金花专属
        } = newVal; 
        const showDetails = (
            !!id
            && modalQueryParam === 'BetDetails'
        );
        isFuturesGame.value = id.includes('futures:'); // 特殊游戏
        isRedpacketGame.value = id.includes('redpacket:'); // 特殊游戏
        isGoldenflowerGame.value = id.includes('zhajinhua:'); // 特殊游戏
        
        showModal.value = showDetails; // 开or关窗口 
        currentIndex.value = 0;
        // ↓ 无论开/关窗口，都要删除之前旧数据的痕迹 
        // ↓ 后续接口查到数据后会为此赋值，并以此驱动游戏结果的展现（没 _id 就不展现，防止出错）
        if (history.value){
            history.value['_id'] = null;
        }
        if (showDetails) {
            if (isRedpacketGame.value){
                const [_, groupId] = id.split(':');
                EMIT_GET_REDPACKET_DETAIL({groupId}, (data)=>{
                    if (data) data.playerId = playerId; 
                    setHistoryData(data); 
                }); 
            } else if(isGoldenflowerGame.value){
                const [_, groupId] = id.split(':');
                EMIT_ZHAJINHUA_DETAIL({ gamePlayId, orderId: groupId }, setHistoryData);
            } else{
                EMIT_BET_DETAILS({ id }, setHistoryData);
            }
        }else if(hasPrincipleShowed === false){
            // ↑ 公平性说明窗口“没曾打开”才在这里处理跳转，否则在公平性说明窗口中处理跳转 
            // ↓ 关窗口时，如果没登录跳到特定页面 
            if (type === 'query'){
                jumpToNoLogPageByState();
            }
        }
    };
    return fnResult;
}

// ↓ 保存查询到的游戏历史数据
function setHistoryData(data){
    const hasError = !data || data.error; 
    if (import.meta.dev){
        console.log(`查询某局游戏的历史数据如下：\n`, data);
    }
    if (hasError) {
        showNegativeNotify(data?.error); 
        return;
    }
    // crash 游戏
    if (data.gameId === 7) {
        data.multi ||= Number(data.stopped).toFixed(2);
    } else if (isFuturesGame.value) { // 期货合约 
        Object.assign(data, getInfo4Rows(data));
    } else if (isRedpacketGame.value) {
        Object.assign(data, fnOperateHistoryDetail(data));
    } else if (isGoldenflowerGame.value) {
        Object.assign(data, {
            _id: data.orderId, timestamp: data.timestamp * 1000,
            user: {
                name: data.userName,
            },
            game: { id: data.gameId },
        });
    }
    nextTick(()=>{
        history.value = (data as any);
    });
}

/**
 * CoinFlip游戏Multiply模式下使用
 * @param index 下标
 */
const handleSelectItem = (index) => {
    currentIndex.value = index;
}

// ↓ 打开公平性窗口 
const fnHandlePrinciple = ()=>{
    hasPrincipleShowed = true; 
    emit('handlePrinciple'); // 发送事件（打开说明窗口）
    onUpdateModelValue(false); // 关闭游戏详情窗口 
};

</script>

